import { render, staticRenderFns } from "./ReferralHistory.vue?vue&type=template&id=3b8dd3e1&scoped=true"
import script from "./ReferralHistory.vue?vue&type=script&lang=js"
export * from "./ReferralHistory.vue?vue&type=script&lang=js"
import style0 from "./ReferralHistory.vue?vue&type=style&index=0&id=3b8dd3e1&prod&lang=scss&scoped=true"
import style1 from "./ReferralHistory.vue?vue&type=style&index=1&id=3b8dd3e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8dd3e1",
  null
  
)

export default component.exports